import React from 'react';
import Pill from 'components/Pill';
import ContentProgressCircle, { useProgressLabel } from 'components/ContentProgressCircle';
export default function ContentProgressPill(_ref) {
  var contentName = _ref.contentName,
    progress = _ref.progress;
  var progressLabel = useProgressLabel({
    progress: progress
  });
  return /*#__PURE__*/React.createElement(Pill, {
    iconRenderer: function iconRenderer() {
      return /*#__PURE__*/React.createElement(ContentProgressCircle, {
        infoReadout: "hidden",
        contentName: contentName,
        progress: progress
      });
    }
  }, progressLabel);
}